import { literal } from 'zod';

import { BaseSweepstakesSchema } from './base-sweepstakes.schema';

// Schema for the initial form state before a `sweepstakesType` is selected.
export const DraftSweepstakesSchema = BaseSweepstakesSchema.extend({
  sweepstakesType: literal(null),
});
